import axios from 'axios'

import { jsonToGraphQLQuery } from 'json-to-graphql-query'
import axiosObj from './config'
import { handleQuery } from '../utils/request'

const LOCATION_API_URL = `${process.env.API_URL}/location/graphql`

const LOCATION_VALUES = {
  _id: true,
  name: true,
  description: true,
  tags: true,
  address: true,
  createdAt: true,
  updatedAt: true,
  visibility: true,
  isDefault: true,
  demoData: true,
  coordinates: {
    lat: true,
    lng: true
  },
  accessList: {
    _id: true,
    firstName: true,
    lastName: true,
  },
  devices: {
    _id: true,
    name: true,
  },
  createdBy: {
    _id: true,
    firstName: true,
    lastName: true,
  }
};

export function createLocation(params) {
  const query = {
    mutation: {
      createLocation: {
        __args: params
      }
    }
  }
  const gqlQuery = jsonToGraphQLQuery(query, { pretty: true })

  return axiosObj({
    method: 'POST',
    url: LOCATION_API_URL,
    data: {
      variables: {},
      query: gqlQuery
    }
  })
}

export function getLocationList(params) {
  const query = {
    query: {
      locations: {
        __args: params,
        count: true,
        data: LOCATION_VALUES
      }
    }
  }
  const gqlQuery = jsonToGraphQLQuery(query, { pretty: true })

  return axiosObj({
    method: 'POST',
    url: LOCATION_API_URL,
    data: {
      variables: {},
      query: gqlQuery
    }
  })
}

export function getLocationDetail(params) {
  const query = {
    query: {
      location: {
        __args: params,
        ...LOCATION_VALUES
      }
    }
  }
  const gqlQuery = jsonToGraphQLQuery(query, { pretty: true })

  return axiosObj({
    method: 'POST',
    url: LOCATION_API_URL,
    data: {
      variables: {},
      query: gqlQuery
    }
  })
}

export function getUserLocations(params) {
  const query = {
    query: {
      userLocations: LOCATION_VALUES
    }
  }
  
  return handleQuery(query, LOCATION_API_URL)
}

export function updateLocation(params) {
  const query = {
    mutation: {
      updateLocation: {
        __args: params
      }
    }
  }
  const gqlQuery = jsonToGraphQLQuery(query, { pretty: true })

  return axiosObj({
    method: 'POST',
    url: LOCATION_API_URL,
    data: {
      variables: {},
      query: gqlQuery
    }
  })
}

export function deleteLocation(params) {
  const query = {
    mutation: {
      deleteLocation: {
        __args: params
      }
    }
  }
  const gqlQuery = jsonToGraphQLQuery(query, { pretty: true })

  return axiosObj({
    method: 'POST',
    url: LOCATION_API_URL,
    data: {
      variables: {},
      query: gqlQuery
    }
  })
}

export function deleteLocations(params) {
  const query = {
    mutation: {
      deleteLocations: {
        __args: params
      }
    }
  }
  const gqlQuery = jsonToGraphQLQuery(query, { pretty: true })

  return axiosObj({
    method: 'POST',
    url: LOCATION_API_URL,
    data: {
      variables: {},
      query: gqlQuery
    }
  })
}

export function locationTags() {
  const query = {
    query: {
      locationTags
    }
  }
  const gqlQuery = jsonToGraphQLQuery(query, { pretty: true })

  return axiosObj({
    method: 'POST',
    url: LOCATION_API_URL,
    data: {
      variables: {},
      query: gqlQuery
    }
  })
}

export function updateLocationTags(params) {
  const query = {
    mutation: {
      bulkUpdateLocationTags: {
        __args: params
      }
    }
  }
  const gqlQuery = jsonToGraphQLQuery(query, { pretty: true })

  return axiosObj({
    method: 'POST',
    url: LOCATION_API_URL,
    data: {
      variables: {},
      query: gqlQuery
    }
  })
}
